import { useState, useEffect } from "react";

// Matches the audit-mobile.css short-landscape breakpoint (max-height:560px)
// so JS-driven behaviour (e.g. gating when task cards may appear) stays in
// lockstep with the CSS-driven layout changes.
const QUERY = "(max-height: 560px)";

export function useIsMobileAudit() {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}

export default useIsMobileAudit;
